import { LinearGradient } from "expo-linear-gradient";
import usePalette from "src/hooks/usePalette";

// There's a bug on iOS which caused the gradient to be a bit too short
// We add a safety margin to ensure there's never gaps
const SafetyMargin = 2;
const GatheringHeaderRegularThumbnailGradient = ({
	direction,
	height,
}: {
	direction: "TopDown" | "BottomUp";
	height: number;
}) => {
	const { tertiary } = usePalette();

	return (
		<LinearGradient
			pointerEvents="none"
			colors={["transparent", tertiary]}
			locations={[0, 1]}
			start={{
				x: 0,
				y: direction === "TopDown" ? 1 : 0,
			}}
			end={{
				x: 0,
				y: direction === "TopDown" ? 0 : 1,
			}}
			style={{
				width: "100%",
				height: height + SafetyMargin,
				top: direction === "TopDown" ? -SafetyMargin : undefined,
				bottom: direction === "BottomUp" ? height - SafetyMargin : undefined,
			}}
		/>
	);
};
export default GatheringHeaderRegularThumbnailGradient;
